import React from 'react'
import PropTypes from 'prop-types'
import { Heading } from '@chakra-ui/react'


const stringWithoutFirstWord = (str) => {
    const indexOfSpace = str.indexOf(' ')

    if (indexOfSpace === -1) {
        return ''
    }

    return str.substring(indexOfSpace + 1)
}

const firstWordOfString = (str) => {
    return typeof str.split(' ')[0] !== 'undefined' ? str.split(' ')[0] : str
}

const InnerTitle = ({title, mainColor, secColor}) => {
    const first = firstWordOfString(title)
    const second = stringWithoutFirstWord(title)

    return (
        <>
            <Heading size={['xl', '2xl', '3xl']} p={[0,0,'10px']} m={[0,0,'10px']} color={mainColor}>
                {first}
            </Heading>
            <Heading size={['xl', '2xl', '3xl']} p={[0,0,'10px']} m={[0,0,'10px']} color={secColor}>
                {second}
            </Heading>
        </>
    )
}

InnerTitle.propTypes = {
    title: PropTypes.string,
    mainColor: PropTypes.string,
    secColor: PropTypes.string,
    fontSize: PropTypes.string,
}

InnerTitle.defaultProps = {
    title: 'Title Placeholder',
    mainColor: '#000',
    secColor: '#fff',
    fontSize: '2rem',
}

export default InnerTitle
